export default __webpack_public_path__ + "static/P22MackinacPro-Book-927faffc35a69127ac14a5d9abdbf513.woff";